import { useTranslation } from "react-i18next"

import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { useGeneralSettings } from "@/hooks/use-module-settings"

export function FollowUpQuestionsCheckbox() {
  const { t } = useTranslation()

  const { settings, updateSettings } = useGeneralSettings()
  const suggestFollowupQuestions = settings?.suggestFollowupQuestions ?? false

  function handleCheckedChange(checked: boolean) {
    // Optimistic update to database
    void updateSettings({ suggestFollowupQuestions: checked })
  }

  return (
    <section className="flex items-center gap-2">
      <Checkbox
        checked={suggestFollowupQuestions}
        id="follow-up-questions"
        onCheckedChange={handleCheckedChange}
      />
      <Tooltip>
        <TooltipTrigger>
          <Label htmlFor="follow-up-questions">
            {t("pages.common.suggest_followup_questions")}
          </Label>
        </TooltipTrigger>
        <TooltipContent className="max-w-[250px]" side="top">
          <p>{t("settingsmenu.follow_up_questions")}</p>
        </TooltipContent>
      </Tooltip>
    </section>
  )
}
